
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetokolhapurcab() {



    const cardData =
    {
        keyword: 'Pune To Kolhapur Cab Booking',
        heading: 'Mauli Cabs: Pune To Kolhapur Cab Booking',
        headingDescription: 'Mauli Cabs offers convenient and reliable Pune to Kolhapur cab booking services, ensuring a smooth and comfortable journey to the historic city of Kolhapur. Whether you are traveling for religious purposes, cultural exploration, or a family trip, we provide a variety of vehicles including sedans, SUVs, and premium cars. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Kolhapur.',

        top: 'Top Places to Visit in Kolhapur with Mauli Cabs',

"topPlaces": [
    {
        "title": "Mahalakshmi Temple",
        "description": "The Mahalakshmi Temple in Kolhapur is one of the 6 Shakti Peethas in India, dedicated to Goddess Mahalakshmi. It is a highly revered temple and an important pilgrimage site for devotees seeking blessings from the goddess."
    },
    {
        "title": "Rankala Lake",
        "description": "Rankala Lake is a beautiful artificial lake located in the heart of Kolhapur. The lake is a popular spot for evening walks and boating, offering a peaceful and scenic atmosphere."
    },
    {
        "title": "Panhala Fort",
        "description": "Panhala Fort, situated about 20 km from Kolhapur, is a historic hill fort known for its strategic importance during the Maratha Empire. The fort offers stunning panoramic views of the surrounding areas and has a rich history dating back to the 12th century."
    },
    {
        "title": "Jyotirlinga Temple (Kedarnath Temple)",
        "description": "The Kedarnath Temple in Kolhapur is dedicated to Lord Shiva and is one of the 12 Jyotirlingas. It is a significant religious site, attracting devotees who come to seek blessings from Lord Shiva."
    },
    {
        "title": "Maharaja's Palace (Shahu Maharaj Palace)",
        "description": "The Maharaja's Palace, also known as the Shahu Maharaj Palace, is an architectural marvel with beautiful gardens, historical artifacts, and stunning royal rooms. It offers a glimpse into the royal life of Kolhapur’s past rulers."
    },
    {
        "title": "Kolhapur Chappal Market",
        "description": "Kolhapur is famous for its unique handcrafted Kolhapuri chappals. The market in Kolhapur is the best place to purchase these iconic sandals, which are made from leather and are renowned for their durability and craftsmanship."
    },
    {
        "title": "Bhavani Mandap",
        "description": "Bhavani Mandap is an ancient temple and heritage site located in the heart of Kolhapur. It is dedicated to Goddess Bhavani and has significant religious and cultural importance in the region."
    },
    {
        "title": "New Palace",
        "description": "The New Palace in Kolhapur is an impressive structure that once served as the residence of the Kolhapur princely state. The palace is known for its colonial architecture, vast gardens, and rich historical significance."
    },
    {
        "title": "Kopeshwar Temple",
        "description": "Kopeshwar Temple is a stunning 12th-century temple located near Kolhapur, dedicated to Lord Shiva. It is famous for its intricate carvings, beautiful architecture, and spiritual atmosphere."
    },
    {
        "title": "Sahyadri Mountain Range",
        "description": "The Sahyadri Mountain Range offers picturesque views, trekking opportunities, and wildlife. The mountains around Kolhapur are perfect for nature lovers and adventure enthusiasts."
    }
],

"services": [
    {
        "name": "Pune to Kolhapur Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable cab services from Pune to Kolhapur. Travel in style and comfort to one of Maharashtra's most historical and culturally rich destinations."
    },
    {
        "name": "Book Pune to Kolhapur Taxi",
        "description": "Book your taxi from Pune to Kolhapur with Mauli Cabs. We provide a simple and hassle-free booking process for a comfortable journey to Kolhapur."
    },
    {
        "name": "Affordable Pune to Kolhapur Cab",
        "description": "Mauli Cabs offers affordable taxi services from Pune to Kolhapur. Enjoy budget-friendly pricing without compromising on comfort or quality."
    },
    {
        "name": "Private Taxi for Kolhapur from Pune",
        "description": "Travel privately to Kolhapur from Pune with Mauli Cabs. Our personalized taxi services ensure a peaceful and relaxed ride, catering to your specific needs."
    },
    {
        "name": "Kolhapur Trip by Cab from Pune",
        "description": "Mauli Cabs offers convenient and reliable taxi services for your trip from Pune to Kolhapur. Whether it's for business or leisure, travel with ease and comfort."
    },
    {
        "name": "Pune to Kolhapur One-Way or Round Trip",
        "description": "Mauli Cabs provides flexible one-way and round-trip taxi services from Pune to Kolhapur. Enjoy the convenience of customized travel plans to suit your needs."
    },
    {
        "name": "Comfortable Taxi Ride to Kolhapur",
        "description": "Travel in comfort and style to Kolhapur with Mauli Cabs. Our well-maintained fleet of vehicles ensures a smooth and relaxed journey, making your trip enjoyable."
    },
    {
        "name": "Group Travel to Kolhapur",
        "description": "Mauli Cabs offers spacious and comfortable vehicles for group travel from Pune to Kolhapur. Travel with family or friends in comfort and style."
    },
    {
        "name": "Luxury Taxi for Kolhapur Trip",
        "description": "Experience luxury while traveling to Kolhapur from Pune with Mauli Cabs. Our premium taxis offer top-tier comfort and style, ensuring a memorable journey."
    },
    {
        "name": "Kolhapur Sightseeing by Taxi",
        "description": "Mauli Cabs offers sightseeing taxi services in Kolhapur. Explore the city's historical landmarks, temples, and attractions in comfort and style with a professional driver."
    }
],

"tableData": [
    ["Pune to Kolhapur Cab Service", "Book Pune to Kolhapur Taxi"],
    ["Affordable Pune to Kolhapur Cab", "Private Taxi for Kolhapur from Pune"],
    ["Kolhapur Trip by Cab from Pune", "Pune to Kolhapur One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Kolhapur", "Group Travel to Kolhapur"],
    ["Luxury Taxi for Kolhapur Trip", "Kolhapur Sightseeing by Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs ensures reliable and punctual service for your Pune to Kolhapur Cab Booking. Our drivers are committed to providing timely pickups and drop-offs, allowing you to travel without any delays and enjoy your time in Kolhapur."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Kolhapur trip, we offer a variety of comfortable vehicles, including sedans, SUVs, and premium cars. All our vehicles are air-conditioned, spacious, and well-maintained, ensuring a comfortable and smooth ride throughout your journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes to Kolhapur. They ensure a smooth, safe, and pleasant ride, following the best traffic patterns to make your journey hassle-free."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable pricing for your Pune to Kolhapur Cab Booking, with no hidden charges. We believe in transparent pricing, ensuring you get the best value for your money without any surprises."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our top priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring a safe and secure journey from Pune to Kolhapur."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Kolhapur trip. Whether you need an early morning ride or a late-night return, our customer service team is always available to assist you with booking your cab at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Kolhapur cab with Mauli Cabs is quick and easy. You can book online via our website or mobile app, or reach out to our customer service team for personalized assistance and seamless booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Kolhapur trip. Whether you're traveling for business, leisure, or visiting the famous Mahalakshmi Temple, we can tailor your trip to suit your preferences and schedule."
    }
]

















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Kolhapur with Mauli Cabs?',
            answer: 'Booking your cab from Pune to Kolhapur is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Kolhapur as your destination, then choose the vehicle that suits your needs. Alternatively, you can call our customer support team for assistance with your booking.',
        },
        {
            question: 'What types of cabs are available for the Pune to Kolhapur trip?',
            answer: 'Mauli Cabs offers a variety of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and premium options for your trip to Kolhapur. You can choose a vehicle based on your group size, comfort, and budget.',
        },
        {
            question: 'Is the fare for the Pune to Kolhapur trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges, with no hidden costs. The total fare is provided upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Kolhapur take?',
            answer: 'The journey from Pune to Kolhapur typically takes around 5 to 6 hours, depending on traffic and road conditions. Our drivers ensure a smooth and comfortable ride to make the trip pleasant for you.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Kolhapur route?',
            answer: 'Yes, Mauli Cabs drivers are experienced with the Pune to Kolhapur route. They are familiar with the best routes and ensure a safe, comfortable, and timely journey to your destination.',
        },
        {
            question: 'Can I book a round trip from Pune to Kolhapur?',
            answer: 'Yes, you can book a round trip to Kolhapur. Just provide your return details when making the booking, and we will ensure a smooth and timely return journey to Pune.',
        },
        {
            question: 'Can I make stops for sightseeing along the way to Kolhapur?',
            answer: 'Yes, you can customize your journey by making stops for sightseeing along the way. Whether you want to visit temples, scenic spots, or take a short break, our drivers will be happy to accommodate your requests.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and maintained for cleanliness and comfort. We prioritize your comfort and ensure a pleasant ride to Kolhapur.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy via our website or app, and our customer support team is available to assist you at any time.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Kolhapur trip?',
            answer: 'Mauli Cabs offers reliable and professional service, competitive pricing, a range of vehicle options, and experienced drivers. We ensure that your journey to Kolhapur is comfortable, safe, and hassle-free.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Deepak Desai",
            position: "Business Traveler",
            text: "My trip to Kolhapur with Mauli Cabs was very smooth and comfortable. The driver was punctual and professional, and the vehicle was in great condition. The ride was pleasant, and I had a wonderful experience. I highly recommend Mauli Cabs for anyone traveling to Kolhapur!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priyanka Patil",
            position: "Spiritual Traveler",
            text: "I had a fantastic trip to Kolhapur with Mauli Cabs. The vehicle was clean, the driver was courteous and knowledgeable about the route, and the journey was very comfortable. Mauli Cabs made our trip stress-free, and I would definitely use them again for future trips!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Kolhapur Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Kolhapur. Choose from private, luxury, or group taxis for a one-way or round-trip journey. Enjoy a smooth and reliable ride to Kolhapur with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
    
      

    return (
        <div>
            <GTag/>
  <Helmet>
        <title>Pune to Kolhapur Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Kolhapur cab with Mauli Cabs. Choose from affordable, private, luxury, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Kolhapur cab service, Book Pune to Kolhapur taxi, Affordable Pune to Kolhapur cab, Private taxi for Kolhapur from Pune, Kolhapur trip by cab from Pune, Pune to Kolhapur one-way or round trip, Comfortable taxi ride to Kolhapur, Group travel to Kolhapur, Luxury taxi for Kolhapur trip, Kolhapur sightseeing by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>



            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokolhapurcab;